import {Int, positive, Schema} from 'effect/Schema';

export const AccountId = Int.pipe(positive()) as unknown as Schema<AccountId>;
export type AccountId = import('../src/AccountId').AccountId;
